module.exports = __webpack_public_path__ + "img/footer.2f97f28f.png";